import SideNavItem from './sidenav-item';

export default SideNavItem;